import Delete from "@mui/icons-material/Delete";
import Grid2 from "@mui/material/Grid2";
import IconButton from "@mui/material/IconButton";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { getFieldPath } from "../../Common/SchemaUtils";

const DateFormFields: React.FC<{
  extractionId: string;
  extractionPath?: string;
  label?: string;
  remove?: Function;
}> = ({ extractionId, extractionPath, label, remove }) => {
  const { control } = useFormContext();
  return (
    <Grid2 container spacing={2} sx={{ alignItems: "center" }}>
      <Grid2 size={remove !== undefined ? 11 : 12}>
        <Controller
          name={`extraction.${getFieldPath([
            extractionId,
            "value",
            extractionPath,
          ])}`}
          control={control}
          render={({ field, fieldState: { error } }) => (
            <DatePicker
              {...field}
              value={dayjs(field.value)}
              onChange={(newValue) =>
                field.onChange(newValue?.format("YYYY-MM-DD"))
              }
              label={label}
              format="DD/MM/YYYY"
              slotProps={{
                textField: {
                  fullWidth: true,
                  helperText: error ? error.message : "",
                  error: !!error,
                  size: "small",
                },
              }}
            />
          )}
        />
      </Grid2>
      {remove !== undefined && (
        <Grid2 size={1} sx={{ textAlign: "right" }}>
          <IconButton
            onClick={() => {
              remove();
            }}
            className="rounded-full"
            size="small"
          >
            <Delete color="error" />
          </IconButton>
        </Grid2>
      )}
    </Grid2>
  );
};

export default DateFormFields;
